/** Fixed product roles; never a custom RBAC builder. */
export const ACCESS_ROLES = {
  aot_admin: {
    label: 'AOT Platform Admin',
    capabilities: 'Platform users, customer tenants and initial owner invitations',
  },
  aot_operator: {
    label: 'AOT Operations Admin',
    capabilities: 'Assigned managed operations; no customer user administration',
  },
  aot_viewer: {
    label: 'AOT Support Viewer',
    capabilities: 'Assigned read-only operational access',
  },
  tenant_owner: {
    label: 'Customer Owner',
    capabilities: 'Users, monitoring, reports, security and ownership',
  },
  tenant_admin: {
    label: 'Customer Admin',
    capabilities: 'Operators, viewers and auditors; monitoring and reports',
  },
  tenant_operator: { label: 'Operator', capabilities: 'Monitoring operations and configuration' },
  tenant_viewer: { label: 'Viewer', capabilities: 'Read-only operations' },
  tenant_auditor: {
    label: 'Auditor',
    capabilities: 'Read-only operations, evidence, reports and audit',
  },
} as const;
export type AccessRole = keyof typeof ACCESS_ROLES;
export const roleLabel = (role: string) =>
  ACCESS_ROLES[role as AccessRole]?.label ?? 'Workspace member';
export function invitableRoles(actor: string, staff = false): AccessRole[] {
  if (staff) return actor === 'aot_admin' ? ['aot_admin', 'aot_operator', 'aot_viewer', 'tenant_owner'] : [];
  if (actor === 'aot_admin') return ['tenant_owner'];
  if (actor === 'tenant_owner')
    return ['tenant_admin', 'tenant_operator', 'tenant_viewer', 'tenant_auditor'];
  if (actor === 'tenant_admin') return ['tenant_operator', 'tenant_viewer', 'tenant_auditor'];
  return [];
}
export function mayManageMember(actor: string, target: string, staff = false): boolean {
  if (staff) return actor === 'aot_admin' && target.startsWith('aot_');
  if (actor === 'tenant_owner') return target.startsWith('tenant_');
  return invitableRoles(actor).includes(target as AccessRole) && actor === 'tenant_admin';
}
